import { Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import Club from "./Club";
import FundingScoutRun from "./FundingScoutRun";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    funding_scout_run_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    item_key: {
      type: "string",
    },
    kind: {
      type: "enum",
      enumType: "phase" as Database["public"]["Enums"]["funding_scout_run_activity_kind"],
    },
    label: {
      type: "string",
    },
    message: {
      type: "string",
    },
    sort_order: {
      type: "number",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    account: reference(() => Account as any, "account_id"),
    club: reference(() => Club as any, "club_id"),
    funding_scout_run: reference(() => FundingScoutRun as any, "funding_scout_run_id"),
  },
);

interface FundingScoutRunActivity extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_scout_run_activity", config)
class FundingScoutRunActivity extends Model<typeof config> {}

export default FundingScoutRunActivity;
